import React from 'react';
import { motion } from 'framer-motion';

interface LoadMoreButtonProps {
  visibleCourses: number;
  coursesLength: number;
  loadMore: () => void;
}

const LoadMoreButton: React.FC<LoadMoreButtonProps> = ({
  visibleCourses,
  coursesLength,
  loadMore,
}) => {
  if (visibleCourses >= coursesLength) {
    return null;
  }

  return (
    <motion.div
      className="text-center mt-8"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <button
        onClick={loadMore}
        className="px-6 py-3 bg-gradient-to-r from-[#017e6e] to-emerald-500 hover:from-[#015d5b] hover:to-emerald-600 text-white font-semibold rounded-lg transition-all transform hover:scale-105 shadow-lg dark:shadow-dark-md"
      >
        Xem thêm
      </button>
    </motion.div>
  );
};

export default LoadMoreButton;
